<template>
  <div>
    <breadcrumbs :home="vessel.name + ': Transfer to wine license'"/>

      <v-card flat>
        <v-form ref="form" :disabled="!edit">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>

            <v-row dense no-gutters>
              <v-col cols="6" sm="4" lg="3">
                <date-picker v-model="transaction.date"  @change="refresh()"/>
              </v-col>
              <v-col class="text-caption ml-5 mt-3 grey--text">
                {{vesselContents}}
                <span v-if="['Spirit','NonExcise'].includes(vessel.contents.alcoholType)" class="warning--text ml-10">Can only move wine to a Wine License</span>
              </v-col>
            </v-row>

            <v-row dense >
              <v-col cols="12">
                <v-text-field label="Comments" v-model="transaction.comments" outlined dense counter="255" :rules="[fieldRules.maxLength(255)]"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-divider/>
        <v-card-actions class="px-6">
          <template v-if="transactionId && company.permissions.includes('production.write')">
            <v-switch v-if="transaction.date > company.excisePeriodEnd || edit" :disabled="dirty"
                      v-model="edit" label="Edit" hide-details class="mt-0"/>
            <div v-else class="grey--text">Cannot edit since excise filed to period end {{company.excisePeriodEnd | formatDate}}</div>
          </template>
          <v-spacer/>
          <v-btn :plain="edit" color="primary" @click="cancel">{{edit?'Cancel':'Done'}}</v-btn>
          <v-btn v-if="edit" color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
  </div>

</template>

<script>
import {format} from 'date-fns'
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ExciseVesselTransferToWineLicense',
  mixins: [confirmLeave],
	props: {
    vesselId: {type:String,required:false},
    transactionId: {type:String, required:false}
	},
	data() {
		return {
      init: true,
      edit: false,
      vessel: {name:'',contents:{}},
      saving:false,
      transaction: {vesselId:this.vesselId, date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),comments: ''},
      dirty: false
		}
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    vesselContents() {
      return this.vessel.contents.volume ? this.vessel.contents.alcoholName : '(empty)';
    }
  },
  watch: {
    transaction: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },
	async created() {
    if (this.transactionId) {
      const results = await this.$apiCall(`query ExciseVesselTransferToWineLicense($id:ID!) {
                                              exciseVesselTransferToWineLicense(id:$id) {
                                                vesselId,date,comments
                                              }
                                            }`,
                                          {id:this.transactionId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.transaction = results.data.exciseVesselTransferToWineLicense;
      this.transaction.id = this.transactionId;
    }
    await this.refresh();
    if (!this.transactionId)
      this.edit = true;
    this.$nextTick(() => this.dirty = false);
    this.init = false;
  },

	methods: {
    async refresh() {
      const results = await this.$apiCall(`query ExciseVesselTransferToWineLicense($id:ID!,$date:DateTime!) {
                                              exciseVessel(id:$id) {
                                                id,name,contents(date:$date) {alcoholType,alcoholName,userLicense,volume}
                                              }
                                            }`,
                                          {id:this.transaction ? this.transaction.vesselId : this.vesselId, date:this.transaction.date});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.vessel = results.data.exciseVessel;
      this.$nextTick(() => {this.$refs.form.validate()});
    },
    cancel() {
      this.$router.back();
    },
		async save() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ExciseVesselTransferToWineLicense($input: ExciseVesselTransferToWineLicenseInput!) {
                                              exciseVesselTransferToWineLicenseCreate(input:$input) {id}
                                            }`,
                                          {input:this.transaction});
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.transactionId?'Updated':'Created'} transfer to wine license transaction for ${this.vessel.name}`});
      }
		}
	}
}
</script>